import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import {apiInstanceV2} from '../../Apis/AxiosV2';
import {UploadImage} from '../ShareSlice/shareApi';
import {TABLES} from '../../Apis/Tables';
import {FOODIE_MENU_SERVICE} from '../EndPoints';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const serviceName = "foodie-menu-service";

export const GetMeasurementUnits = createAsyncThunk('ingredient/GetMeasurementUnits ', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(`${serviceName}/v1/measurement-units/get-all`).then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetIngredientById = createAsyncThunk('ingredient/GetIngredientById ', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(`${serviceName}/v1/ingredients/by-id/${params}`).then((response) => {
        return response;
    })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateIngredient = createAsyncThunk("ingredient/CreateIngredient",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(`${serviceName}/v1/ingredients/create`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateIngredient = createAsyncThunk("ingredient/UpdateIngredient",async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(`${serviceName}/v1/ingredients/update`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const CreateIngredientImage = createAsyncThunk(`ingredient/CreateIngredientImage`, async (params, { dispatch, getState }) => {
    const result = await apiInstanceV2.post(`${serviceName}/v1/ingredients/image/create`, params?.imgData).then(async function (response) {
        // this api need id, file and option
                let formData = new FormData();
                formData.append('id', response?.data?.data?.id);
                formData.append('option', 'ingredient');
                formData.append('file', params?.image);
                await dispatch(UploadImage(formData));
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const UpdateIngredientImage = createAsyncThunk('ingredient/UpdateIngredientImage', async (params) => {
    let formData = new FormData();
    formData.append('id', params?.imageId);
    formData.append('option', TABLES.INGREDIENT);
    formData.append('file', params?.image);
    const result = await apiInstance.put('image-service/upload', formData).then(function (response) {
        return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});


export const GetIngredientImageByIngredientId = createAsyncThunk('ingredient/GetIngredientImageByIngredientId', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(`${serviceName}/v1/ingredients/image/by-id/${params}`).then((response) => {
        return response;
    })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const DeleteAllergenById = createAsyncThunk(
  'menu/deleteAllergenById',
  async ({foodieItemId, allergenId }, { dispatch, getState }) => {
    const response = await apiInstance
      .delete(`${serviceName}/v1/items/${foodieItemId}/remove-allergen/${allergenId}`)
      .catch((error) => error.response);

    const { data, status, code } = response;
    return { data, status, code };
  }
);
export const DeleteDietTypeById = createAsyncThunk(
  'menu/deleteDietTypeById',
  async ({foodieItemId, dietTypeId }, { dispatch, getState }) => {
    const response = await apiInstance
      .delete(`${serviceName}/v1/items/${foodieItemId}/remove-diet-type/${dietTypeId}`)
      .catch((error) => error.response);

    const { data, status, code } = response;
    return { data, status, code };
  }
);
export const DeleteIngredientById = createAsyncThunk(
  'menu/deleteIngredientById',
  async ({foodieItemId, ingredientId }, { dispatch, getState }) => {
    const response = await apiInstance
      .delete(`${serviceName}/v1/items/${foodieItemId}/remove-ingredient/${ingredientId}`)
      .catch((error) => error.response);

    const { data, status, code } = response;
    return { data, status, code };
  }
);

export const CheckOutOrderKitchen = createAsyncThunk("ingredient/CheckOutOrderKitchen",async (params, { dispatch, getState }) => {

    const {id, date} = params;
    const response = await apiInstance.get(`${FOODIE_MENU_SERVICE.checkOutOrderKitchen}${id}/${date}`).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const ServedOrderHistory = createAsyncThunk("ingredient/ServedOrderHistory",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(`foodie-menu-selection-service/v1/orders/history-served`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});
